"use client";

import React, { useState } from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext } from "@/components/ui/carousel";
import { Switch } from "@/components/ui/switch";
const renovationProjects = [{
  id: 1,
  title: "Producción Cristiana Inspiradora",
  description: "Música creada con propósito para compartir mensajes de fe, esperanza y confianza en Dios, inspirando vidas a través de cada canción.",
  imageBefore: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689867/img/christian_production_studio.png",
  imageAfter: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689867/img/christian_production_live.png"
}, {
  id: 2,
  title: "Música para Eventos Corporativos",
  description: "Producciones musicales diseñadas para empresas y organizaciones que desean comunicar sus valores, inspirar a su audiencia y fortalecer su presencia a través de la música.",
  imageBefore: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689867/img/corporate_music_setup.png",
  imageAfter: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689867/img/corporate_music_event.png"
}, {
  id: 3,
  title: "Regalos Musicales Personalizados",
  description: "Canciones creadas especialmente para cumpleaños, aniversarios y ocasiones especiales, transformando recuerdos, experiencias y sentimientos en un regalo único y significativo.",
  imageBefore: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689867/img/personal_gift_composition.png",
  imageAfter: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689867/img/personal_gift_delivery.png"
}];
function RenovationSlide({
  project
}: {
  project: typeof renovationProjects[0];
}) {
  const [showAfter, setShowAfter] = useState(true);
  return <div className="relative w-full aspect-[4/3] md:aspect-[21/9] overflow-hidden bg-card border border-border/50 group">
      {}
      <img src={project.imageBefore} alt={`${project.title} - Proceso`} className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ease-in-out ${showAfter ? "opacity-0" : "opacity-100"}`} />
      <img src={project.imageAfter} alt={`${project.title} - Resultado`} className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ease-in-out ${showAfter ? "opacity-100" : "opacity-0"}`} />

      {}
      <div className="absolute top-4 left-4 md:top-8 md:left-8 z-10 flex items-center gap-3 bg-background/80 backdrop-blur-xl px-4 py-3 border border-white/10 shadow-lg rounded-md">
        <span className={`text-xs md:text-sm font-default font-semibold tracking-widest uppercase transition-colors ${!showAfter ? "text-secondary" : "text-muted-foreground"}`}>
          Estudio
        </span>
        <Switch checked={showAfter} onCheckedChange={setShowAfter} />
        <span className={`text-xs md:text-sm font-default font-semibold tracking-widest uppercase transition-colors ${showAfter ? "text-primary" : "text-muted-foreground"}`}>
          Final
        </span>
      </div>

      {}
      <div className="absolute bottom-4 right-4 md:bottom-8 md:right-8 z-10 w-[calc(100%-2rem)] md:w-96 bg-card/90 backdrop-blur-2xl p-6 md:p-8 border border-white/10 shadow-2xl transition-transform duration-500 translate-y-2 group-hover:translate-y-0 rounded-lg">
        <h3 className="font-default text-xl md:text-2xl font-bold mb-3 text-foreground leading-tight tracking-tight">
          {project.title}
        </h3>
        <p className="font-default text-sm md:text-base text-muted-foreground leading-relaxed">
          {project.description}
        </p>
      </div>
    </div>;
}
export default function GalerADeXitos() {
  return <section data-section-id="224255" id="galería-de-éxitos" className="dark py-24 bg-background border-y border-border/30">
      <div className="container mx-auto px-4 md:px-6 mb-12 md:mb-16">
        <div className="max-w-3xl">
          <h2 className="font-default text-3xl md:text-5xl font-bold text-foreground uppercase tracking-widest mb-6">
            Nuestras Producciones
          </h2>
          <p className="font-default text-lg text-muted-foreground">
            Explora algunas de nuestras producciones musicales, desarrolladas para transmitir fe, esperanza e inspiración. Cada canción representa una oportunidad para conectar corazones y compartir mensajes con propósito a través de la música.
          </p>
          <div className="h-1 w-24 bg-gradient-to-r from-primary to-secondary mt-8"></div>
        </div>
      </div>

      <div className="container mx-auto px-4 md:px-6">
        <Carousel opts={{
        loop: true,
        align: "start"
      }} className="w-full relative">
          <CarouselContent>
            {renovationProjects.map((project, i) => <CarouselItem key={project.id} data-index={i}>
                <RenovationSlide project={project} />
              </CarouselItem>)}
          </CarouselContent>
          
          {}
          <div className="hidden md:flex items-center justify-end gap-4 mt-8">
            <CarouselPrevious className="relative left-0 right-0 top-0 bottom-0 translate-x-0 translate-y-0 rounded-md h-14 w-14 border-2 border-border bg-card hover:bg-primary hover:text-primary-foreground transition-all shadow-md" />
            <CarouselNext className="relative left-0 right-0 top-0 bottom-0 translate-x-0 translate-y-0 rounded-md h-14 w-14 border-2 border-border bg-card hover:bg-primary hover:text-primary-foreground transition-all shadow-md" />
          </div>
        </Carousel>
      </div>
    </section>;
}